import { get, post, put, patch } from "../Config"

export function SortTableFeature({ params = {}, data = {} }) {
  return post({ url: `/v1/admin/table-feature/sort-table`, params, data })
}
